import AsyncStorage from '@react-native-async-storage/async-storage';

const getKnowledgeCenterArticleContent = async (url: string) => {
  try {
    const clientName = await AsyncStorage.getItem('clientName');
    const jwtToken = await AsyncStorage.getItem('token');

    // eslint-disable-next-line no-undef
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('clientid', clientName ?? 'hereworks');
    requestHeaders.set('Content-Type', 'application/json');
    requestHeaders.set('jwt', jwtToken ?? '');

    const params: { method: string, headers: Headers } = {
      method: 'GET', headers: requestHeaders,
    };

    return fetch(url, params)
      .then((res) => (res ? res.text().then((json) => json) : null));
  } catch (error) {
    return null;
  }
};

export default getKnowledgeCenterArticleContent;
